require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-what-the-best-urban-renewal-projects-from-around-the.json") })
        }
      }, "path---news-what-the-best-urban-renewal-projects-from-around-the");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-what-the-best-urban-renewal-projects-from-around-the!./.cache/json/news-what-the-best-urban-renewal-projects-from-around-the.json
// module id = 863
// module chunks = 231608221292675